import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.5 4a7.5 7.5 0 0 0-6.618 11.032 1 1 0 0 1 .058.813l-1.267 3.482 3.482-1.267a1 1 0 0 1 .813.058A7.5 7.5 0 1 0 12.5 4M3 11.5a9.5 9.5 0 1 1 5.433 8.587L3.342 21.94a1 1 0 0 1-1.282-1.282l1.853-5.09A9.5 9.5 0 0 1 3 11.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }